import { Grid, TextField } from "@mui/material";
import { StyleHome } from "../../Tool/Style";
import { MOBILE } from "../config";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import es from "date-fns/locale/es";
import en from "date-fns/locale/en-US";

const CustomerAdditionalFields = ({
  customFields,
  etiquetas,
  deviceIs,
  codigoIdioma,
}) => {
  const formatoFecha = "dd/MM/yyyy";
  return (
    <>
      <Grid
        item
        xs={deviceIs === MOBILE ? 12 : 4}
        sm={4}
        md={4}
        style={StyleHome.GridItem}
      >
        <TextField
          disabled={true}
          name="apellidoCasada"
          value={customFields?.apellidoCasada || ""}
          variant="outlined"
          fullWidth
          label={
            etiquetas.InterfazDatosPersonales?.Et_tblCusApellidoCasada ||
            "Apellido de Casada"
          }
        ></TextField>
      </Grid>
      <Grid
        item
        xs={deviceIs === MOBILE ? 12 : 4}
        sm={4}
        md={4}
        style={StyleHome.GridItem}
      >
        <TextField
          disabled={true}
          name="correlativoDPI"
          value={customFields?.correlativoDPI || ""}
          variant="outlined"
          fullWidth
          label={
            etiquetas.InterfazDatosPersonales?.Et_tblCusCorrelativoDPI ||
            "Correlativo DPI"
          }
        />
      </Grid>
      <Grid
        item
        xs={deviceIs === MOBILE ? 12 : 4}
        sm={4}
        md={4}
        style={StyleHome.GridItem}
      >
        <TextField
          disabled={true}
          name="deptoNacimiento"
          value={customFields?.deptoNacimiento || ""}
          variant="outlined"
          fullWidth
          label={
            etiquetas.InterfazDatosPersonales?.Et_tblCusDeptoNacimiento ||
            "Departamento de Nacimiento"
          }
        />
      </Grid>
      <Grid
        item
        xs={deviceIs === MOBILE ? 12 : 4}
        sm={4}
        md={4}
        style={StyleHome.GridItem}
      >
        <LocalizationProvider
          dateAdapter={AdapterDateFns}
          locale={codigoIdioma === "EN" ? en : es}
        >
          <DesktopDatePicker
            disabled={true}
            required
            format="YYYY-MM-DD"
            inputFormat={formatoFecha}
            id="fechaVencimiento"
            name="fechaVencimiento"
            value={customFields.fechaVencimiento}
            variant="outlined"
            label={
              etiquetas.InterfazDatosPersonales.Et_tblFechaVencimiento ||
              "Fecha de Vencimiento"
            }
            renderInput={(params) => <TextField fullWidth {...params} />}
          />
        </LocalizationProvider>
      </Grid>
      <Grid
        item
        xs={deviceIs === MOBILE ? 12 : 4}
        sm={4}
        md={4}
        style={StyleHome.GridItem}
      >
        <TextField
          disabled={true}
          name="muniNacimiento"
          value={customFields?.muniNacimiento || ""}
          variant="outlined"
          fullWidth
          label={
            etiquetas.InterfazDatosPersonales?.Et_tblCusMuniNacimiento ||
            "Municipio de Nacimiento"
          }
        />
      </Grid>
      <Grid
        item
        xs={deviceIs === MOBILE ? 12 : 4}
        sm={4}
        md={4}
        style={StyleHome.GridItem}
      >
        <TextField
          disabled={true}
          name="ocupacion"
          value={customFields?.ocupacion || ""}
          variant="outlined"
          fullWidth
          label={
            etiquetas.InterfazDatosPersonales?.Et_tblCusOcupacion || "Ocupación"
          }
        />
      </Grid>
      <Grid
        item
        xs={deviceIs === MOBILE ? 12 : 4}
        sm={4}
        md={4}
        style={StyleHome.GridItem}
      >
        <TextField
          disabled={true}
          name="ordenCedula"
          value={customFields?.ordenCedula || ""}
          variant="outlined"
          fullWidth
          label={
            etiquetas.InterfazDatosPersonales?.Et_tblCusOrdenCedula ||
            "Orden Cédula"
          }
        />
      </Grid>
      <Grid
        item
        xs={deviceIs === MOBILE ? 12 : 4}
        sm={4}
        md={4}
        style={StyleHome.GridItem}
      >
        <TextField
          disabled={true}
          name="paisNacimiento"
          value={customFields?.paisNacimiento || ""}
          variant="outlined"
          fullWidth
          label={
            etiquetas.InterfazDatosPersonales?.Et_tblCusPaisNacimiento ||
            "País de Nacimiento"
          }
        />
      </Grid>
      <Grid
        item
        xs={deviceIs === MOBILE ? 12 : 4}
        sm={4}
        md={4}
        style={StyleHome.GridItem}
      >
        <TextField
          disabled={true}
          name="registroCedula"
          value={customFields?.registroCedula || ""}
          variant="outlined"
          fullWidth
          label={
            etiquetas.InterfazDatosPersonales?.Et_tblCusRegistroCedula ||
            "Registro Cédula"
          }
        />
      </Grid>
      <Grid
        item
        xs={deviceIs === MOBILE ? 12 : 4}
        sm={4}
        md={4}
        style={StyleHome.GridItem}
      >
        <TextField
          disabled={true}
          name="vecindad"
          value={customFields?.vecindad || ""}
          variant="outlined"
          fullWidth
          label={
            etiquetas.InterfazDatosPersonales?.Et_tblCusVecindad || "Vecindad"
          }
        />
      </Grid>
    </>
  );
};

export default CustomerAdditionalFields;
